import classnames from "classnames";

import 'shared/components/Skeleton/styles.scss';


function Skeleton({className, ...props}) {
    return <div className={classnames("Skeleton", className)} {...props}/>;
}

export default Skeleton;
